// extracted by mini-css-extract-plugin
module.exports = {"basicInfoNode":"CompanyGeneralTab_basicInfoNode__2PwOt"};